const asArray = (value) => (Array.isArray(value) ? value : []);

const findMetro = (item, metros) => {
  const id = item && typeof item === "object" ? (item._id || item.id) : item;
  const name = item && typeof item === "object"
    ? (item.name || item.label || item.value)
    : item;

  return asArray(metros).find((metro) =>
    (id && String(metro?._id || metro?.id) === String(id)) ||
    (name && metro?.name === name)
  );
};

export const toMetroOptions = (assignedMetros, metros = []) =>
  asArray(assignedMetros)
    .map((item) => {
      if (!item) return null;
      const matchedMetro = findMetro(item, metros);
      const name = matchedMetro?.name || (typeof item === "object"
        ? (item.name || item.label || item.value)
        : null);
      return name ? { label: name, value: name } : null;
    })
    .filter(Boolean);

export const normalizeMetroOptions = (selectedMetros, metros = []) =>
  asArray(selectedMetros)
    .map((item) => {
      const matchedMetro = findMetro(item, metros);
      const name = matchedMetro?.name || (typeof item === "object"
        ? (item.name || item.label || item.value)
        : null);
      return name ? { label: name, value: name } : null;
    })
    .filter(Boolean);
